import { useMediaQuery } from '@/shared/lib/useMediaQuery';
import { mobile } from '@/shared/ui/theme';
import { MobileWindowBackButton } from '@/shared/ui/templates';
import { useQuestPanelStore, type QuestScope } from '../QuestListPanel/model/questPanelStore';

interface QuestMobileBackProps {
  /** 어느 창의 상세인가 — 팀 · 월드 퀘스트 창은 상세 열림을 창별로 따로 든다. */
  scope: QuestScope;
}

/**
 * 퀘스트 창들의 모바일 제목줄 앞자리 — 상세에서 목록으로 돌아가는 ‹.
 *
 * 상세 패널 안에 있던 「‹ 목록으로」 버튼은 채움 · 테두리 · 14px 로 한 줄을 통째로 차지했다.
 * 제보 · 요청 창과 같은 `MobileWindowBackButton` 을 쓴다. 작성 · 수정 폼이 떠 있으면 폼의
 * 취소가 그 자리라 숨긴다.
 */
export function QuestMobileBack({ scope }: QuestMobileBackProps) {
  const isMobile = useMediaQuery(mobile);
  const open = useQuestPanelStore((st) => st.mobileShowDetailByPanel[scope]);
  const formOpen = useQuestPanelStore((st) => st.detailFormOpenByPanel[scope]);
  const setMobileShowDetail = useQuestPanelStore((st) => st.setMobileShowDetail);

  if (!isMobile || !open || formOpen) return null;

  return <MobileWindowBackButton onClick={() => setMobileShowDetail(scope, false)} />;
}
